// extracted by mini-css-extract-plugin
module.exports = {"socialLinks":"SocialLinks_socialLinks__ocPJv","linkItem":"SocialLinks_linkItem__8_B0T","link":"SocialLinks_link__5_nEi"};